import { defineComponent } from "vue";
import ThemesHelper from "@/helpers/ThemesHelper";

export default defineComponent({
  mounted() {
    // a delay is required to set theme
    setTimeout(() => {
      ThemesHelper.setGlobalTheme();
    }, 1);
  },
});
